export default () => {
  if (process.client && !document.getElementById('etrusted-widget-js')) {
    const s = document.createElement('script');
    s.id = 'etrusted-widget-js';
    s.src = 'https://integrations.etrusted.com/applications/widget.js/v2';
    s.async = true;
    s.defer = true;
    document.head.appendChild(s);
  }
};
